import { SupportAgent } from '@mui/icons-material';
import { Fab, useMediaQuery, useTheme } from '@mui/material';

const LINE_CONTACT_URL = 'https://line.me/R/ti/p/@969xdkze';

const DesktopContactUsFab = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery('(hover: none)');
  const isBiggerThanMd = useMediaQuery(theme.breakpoints.up('md'));
  const isDesktop = isBiggerThanMd && !isMobile;

  if (!isDesktop) {
    return null;
  }

  return (
    <Fab
      color="primary"
      component="a"
      href={LINE_CONTACT_URL}
      target="_blank"
      rel="noopener noreferrer"
      sx={(muiTheme) => ({
        position: 'fixed',
        right: { md: 24, lg: 32 },
        bottom: muiTheme.spacing(12),
      })}
    >
      <SupportAgent />
    </Fab>
  );
};

export default DesktopContactUsFab;
